<template>
  <div class="card__wrapper mb-md">
    <router-link
      :to="'/projekte/' + encodeURIComponent(URLtitle) + '/' + id"
      class="projekt__card"
    >
      <div class="image_wrapper">
        <img
          :src="imageSrc"
          :alt="title"
          class="projekt__image"
          loading="lazy"
        />
      </div>
      <div class="projekt__info">
        <h2 class="projekt__title">{{ title }}</h2>
        <p class="projekt__category">{{ category }}</p>
      </div>
    </router-link>
  </div>
</template>

<script setup>
const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  category: {
    type: String,
    required: true,
  },
  URLtitle: {
    type: String,
    required: true,
  },
  id: {
    type: Number,
    required: true,
  },
  imageSrc: {
    type: String,
    required: true,
  },
});
</script>

<style scoped lang="scss">
.card__wrapper {
  a {
    color: $text--col;
    display: flex;
    flex-direction: column;
    gap: map-get($spaces, "xs");
  }
  .image_wrapper {
    width: auto;
    height: 25em;
    border-radius: map-get($spaces, "xxs");
    &:hover {
      transform: scale(1.02);
    }
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: map-get($spaces, "xxs");
    }
  }
  .projekt__info {
    h2 {
      margin-top: map-get($spaces, "xs");
      @media (min-width: 1440px) {
        margin-top: map-get($spaces, "sm");
      }
      font-weight: 520;
      @media (min-width: 768px) {
        font-size: 2rem;
      }
    }
    p {
      color: $text--muted;
    }
  }
}
</style>
